<template>
  <!-- start 导航 -->
  <div class="navigation">
    <div
      class="navigation-bar"
      :class="[
        pattern == 0 ? '' : 'bot-mars',
        isShowActionBar == false ? 'bot-mars' : '',
      ]"
    >
      <div class="navigation-bar-info">
        <div class="return-btn" @click="returnFun">
          <img class="left-icon" src="@/assets/images/left-icon.png" />
          返回
        </div>
        <div class="navigation-bar-title-info">
          <span v-for="(item, key) in menuList" :key="key">
            <template v-if="key + 1 != menuList.length">
              <span class="navigation-bar-title" @click="redirect(item.path)">{{
                item.name
              }}</span>
              <span class="navigation-bar-title-info-decollator">></span>
            </template>
            <template v-else>
              <span class="navigation-bar-title">{{ item.name }}</span>
            </template>
          </span>
        </div>
      </div>
      <div class="navigation-bar-operation" v-if="isShowActionBar" @click.stop>
        <!-- start 测试模式操作 -->
        <div class="navigation-bar-pulldown" v-if="pattern == 0">
          <span class="navigation-bar-pulldown-label">课程选择：</span>
          <div class="pulldown-vessel" @click="isShowPulldownContent">
            <div class="pulldown-vessel-input">
              {{
                null != optionsListThis[index]
                  ? optionsListThis[index].name
                  : ""
              }}
            </div>
            <img class="bottom-icon" src="@/assets/images/bottom-icon.png" />
            <div
              class="pulldown-content"
              v-if="showPulldownContent"
              @click.stop=""
            >
              <div class="pulldown-content-info">
                <div class="pulldown-content-info-content">
                  <input
                    class="pulldown-content-info-content-input"
                    v-model="searchValue"
                    placeholder="请输入课程名称"
                  />
                </div>
              </div>
              <div class="show-content" v-if="optionsListThis.length != 0">
                <div
                  class="option-list"
                  v-for="(item, key) in optionsListThis"
                  :key="key"
                  @click="selectOptions(key)"
                >
                  <!-- <div
                    class="limit-free"
                    v-if="null != item.status && item.status == 0 && !isVip"
                  >
                    免费
                  </div>
                  <div
                    class="limit-free"
                    v-if="null != item.status && item.status == 1 && !isVip"
                  >
                    限免
                  </div>
                  <img
                    class="vip-icon"
                    v-if="null != item.status && item.status == 2 && !isVip"
                    src="@/assets/images/vip-icon.png"
                  /> -->
                  <div class="text-name">{{ item.name }}</div>
                </div>
              </div>
              <div class="not-show-content" v-if="optionsListThis.length == 0">
                没有找到相关的课程,输入其他关键字试试吧!
              </div>
            </div>
          </div>
        </div>
        <!-- end 测试模式操作 -->
        <!-- start 练习模式操作 -->
        <div v-if="pattern == 1" class="practice-mode">
          过关条件：速度达{{ passRate }}字/分，正确率达到{{
            clearanceAccuracy
          }}%
        </div>
        <!-- end 练习模式操作 -->
      </div>
    </div>
    <div class="practice-mode-operation" v-if="pattern == 0 && isShowActionBar">
      <div class="practice-mode-time-limit">
        <div class="time-limit">
          <div>限时</div>
          <input
            class="time-limit-input"
            v-model.number="thisTimeLimit"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            :disabled="!isTimeLimit"
          />
          <div>分钟</div>
        </div>
      </div>
    </div>

    <!-- start 支付-->
    <MembersBuy
      :open="membersBuyOpen"
      @close="membersBuyOpen = false"
      @reloadVipInfo="reloadVipInfo()"
    ></MembersBuy>
    <!-- end 支付-->
    <!-- start 升级VIP-->
    <UpgradeVip
      :open="vipOpen"
      @close="vipOpen = false"
      @upgradeVip="upgradeVip"
    ></UpgradeVip>
    <!-- end 升级VIP-->
    <!-- start 微信登录 -->
    <WeChatLogin
      :open="wxOpen"
      @close="wxOpen = false"
      @wxLoginOk="wxLoginOk"
    ></WeChatLogin>
    <!-- end 微信登录 -->
  </div>
  <!-- end 导航 -->
</template>

<script>
import UpgradeVip from "@/components/UpgradeVip.vue";
import WeChatLogin from "@/components/WeChatLogin.vue";
import MembersBuy from "@/components/MembersBuy.vue";
export default {
  name: "NavigationBar",
  components: {
    UpgradeVip,
    WeChatLogin,
    MembersBuy,
  },
  data() {
    return {
      // 展示课程内容
      showPulldownContent: false,
      // 限时
      thisTimeLimit: this.timeLimit,
      // index
      index: 0,
      // 搜索值
      searchValue: null,
      //菜单列表
      optionsListThis: [],
      //vip弹窗
      vipOpen: false,
      // 支付窗口
      membersBuyOpen: false,
      // 微信登录弹窗
      wxOpen: false,
    };
  },
  props: {
    // 限时
    timeLimit: {
      typeof: Number,
      default: null,
    },
    // 是否可以限时
    isTimeLimit: {
      type: Boolean,
      default: false,
    },
    // 模式[0:练习模式，1:测试模式]
    pattern: {
      typeof: Number,
      default: 0,
    },
    // 是否展示操作栏
    isShowActionBar: {
      typeof: Boolean,
      default: true,
    },
    // 菜单列表
    menuList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 下拉选项
    optionsList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 过关正确率
    clearanceAccuracy: {
      type: Number,
      default: 0,
    },
    // 过关速度
    passRate: {
      type: Number,
      default: 0,
    },
    // 是否微信登录
    isWxLogin: {
      typeof: Boolean,
      default: false,
    },
    // 是否vip
    isVip: {
      typeof: Boolean,
      default: false,
    },
  },
  watch: {
    optionsList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.optionsListThis = newVal;
      },
    },
    // 监听 限时
    timeLimit: {
      handler(newVal) {
        this.thisTimeLimit = newVal;
      },
    },
    //监听 限时
    thisTimeLimit: {
      immediate: true, //首次监听
      deep: true,
      handler(newVal) {
        this.$emit("update:timeLimit", newVal);
      },
    },
    // 监听搜索值
    searchValue: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal == null || newVal == "") {
          this.optionsListThis = this.optionsList;
          return;
        }
        this.optionsListThis = [];
        this.optionsList.forEach((item) => {
          let reg = "^(.*" + this.searchValue + ".*)$";
          if (item.name.match(reg)) {
            this.optionsListThis.push(item);
          }
        });
      },
    },
  },
  methods: {
    // 返回
    returnFun() {
      if (this.menuList.length >= 2) {
        this.$router.push(this.menuList[this.menuList.length - 2].path);
      }
    },
    // 是否展示课程内容
    isShowPulldownContent() {
      this.showPulldownContent = !this.showPulldownContent;
      this.$emit("clickEvent");
    },
    // 选择下拉选项
    selectOptions(key) {
      // if (
      //   null != this.optionsListThis[key].status &&
      //   this.optionsListThis[key].status == 2
      // ) {
      //   this.isWhether(key);
      //   return;
      // }
      this.index = key;
      this.showPulldownContent = false;
      this.$emit("getSelectOptions", this.optionsListThis[key]);
    },
    // 跳转页面
    redirect(path) {
      this.$router.push(path);
    },
    // 检查软件
    reloadVipInfo() {
      this.$emit("reloadVipInfo");
    },
    // 更新数据
    wxLoginOk() {
      this.$emit("wxLoginOk");
      this.examineVip();
    },
    // 检查VIP
    examineVip() {
      let token = localStorage.getItem("token");
      if (token) {
        let data = {
          token: token,
        };
        this.$http({
          url: "https://api.kuaixunda.cn/api/license",
          method: "get",
          params: data,
        }).then(({ data }) => {
          if (data.code == 0) {
            if (data.data.status != 1) {
              this.membersBuyOpen = true;
            }
            if (data.data.status === 1) {
              this.$store.commit("setIsVip", true);
            }
          }
        });
      }
    },
    // 升级VIp
    upgradeVip() {
      if (this.isWxLogin) {
        this.membersBuyOpen = true;
        this.vipOpen = false;
        return;
      }
      this.wxOpen = true;
      this.vipOpen = false;
    },
    // 是否vip
    isWhether(key) {
      let token = localStorage.getItem("token");
      if (token) {
        let data = {
          token: token,
        };
        this.$http({
          url: "https://api.kuaixunda.cn/api/license",
          method: "get",
          params: data,
        }).then(({ data }) => {
          if (data.code == 0) {
            if (data.data.status == 1) {
              this.$store.commit("setIsVip", true);
              this.index = key;
              this.showPulldownContent = false;
              this.$emit("getSelectOptions", this.optionsListThis[key]);
            } else {
              this.vipOpen = true;
              this.showPulldownContent = false;
            }
          }
          if (data.code == 403) {
            this.$emit("Logout");
          }
        });
      } else {
        this.vipOpen = true;
        this.showPulldownContent = false;
      }
    },
  },
  mounted() {
    document.body.addEventListener(
      "click",
      () => {
        this.showPulldownContent = false;
      },
      false
    );
  },
};
</script>

<style scoped lang="scss">
.navigation-bar {
  margin-top: 14px;
  padding: 0 14px;
  display: flex;
  justify-content: space-between;
  .navigation-bar-info {
    display: flex;
    .return-btn {
      width: 68px;
      height: 28px;
      background: #f6f6f6;
      border-radius: 3px 3px 3px 3px;
      border: 1px solid #91b0dc;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: #000000;
      font-weight: 400;
      cursor: pointer;
      .left-icon {
        width: 5px;
        height: 8px;
        margin-right: 4px;
      }
    }
    .navigation-bar-title-info {
      margin-left: 20px;
      color: #000000;
      font-weight: 400;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      .navigation-bar-title {
        cursor: pointer;
      }
      .navigation-bar-title-info-decollator {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  .navigation-bar-operation {
    .navigation-bar-pulldown {
      display: flex;
      .navigation-bar-pulldown-label {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .pulldown-vessel {
        width: 160px;
        height: 21px;
        display: flex;
        position: relative;
        .pulldown-vessel-input {
          width: 150px;
          height: 21px;
          border: 1px solid #9c9c9c;
          box-sizing: border-box;
          background: #ffffff;
          font-size: 16px;
          color: #000000;
          font-weight: 400;
          display: flex;
          justify-content: center;
          align-items: center;

          word-wrap: break-word; /*强制换行*/
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*隐藏后添加省略号*/
          white-space: nowrap; /*强制不换行*/
        }
        .bottom-icon {
          width: 22px;
          height: 21px;
        }
        .pulldown-content {
          bottom: -197px;
          right: 0px;
          position: absolute;
          width: 264px;
          height: 198px;
          box-sizing: border-box;
          border: 1px solid #9c9c9c;
          background: #ffffff;
          z-index: 999;
          .pulldown-content-info {
            width: 100%;
            height: 24px;
            background: #eef2f6;
            display: flex;
            justify-content: flex-end;
            .pulldown-content-info-content {
              display: flex;
              align-items: center;
              width: 120px;
              padding-right: 6px;
              .pulldown-content-info-content-input {
                outline: none;
                width: 100%;
                height: 14px;
                border: 0.5 solid grey;
                font-size: 16px;
                color: grey;
              }
            }
          }
          .not-show-content {
            flex: 1;
            overflow-y: scroll;
            height: 172px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            text-indent: 20px;
            line-height: 40px;
            font-size: 16px;
            color: grey;
          }
          .show-content {
            flex: 1;
            overflow-y: scroll;
            height: 172px;
            // display: flex;
            // flex-wrap: wrap;
            .option-list {
              float: left;
              width: 50%;
              height: 21px;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              margin-bottom: 0;
              line-height: 21px;
              padding-left: 11px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              cursor: pointer;
              .limit-free {
                width: 24px;
                height: 15px;
                background: #f83a3a;
                border-radius: 2px 2px 2px 2px;
                font-size: 11px;
                font-weight: 400;
                color: #ffffff;
                line-height: 15px;
              }
              .vip-icon {
                width: 14px;
                height: 16px;
                margin-left: 5px;
                margin-right: 5px;
              }
              .text-name {
                margin-left: 2px;
                flex: 1;
                word-wrap: break-word; /*强制换行*/
                overflow: hidden; /*超出隐藏*/
                text-overflow: ellipsis; /*隐藏后添加省略号*/
                white-space: nowrap; /*强制不换行*/
              }
            }
            .option-list:hover {
              font-weight: bold;
              background: #dae6f1;
            }
          }
          .idler-wheel {
            width: 16px;
            height: 100%;
          }
        }
      }
    }
    .practice-mode {
      color: #000000;
      font-weight: 400;
      font-size: 16px;
    }
  }
}

.practice-mode-operation {
  margin-top: 8px;
  padding: 0 14px;
  margin-bottom: 27px;
  display: flex;
  justify-content: space-between;
  .practice-mode-time-limit {
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    .time-limit {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 14px;
      .time-limit-input {
        width: 33px;
        height: 19px;
        margin: 0px 4px;
        border: 1px solid #9c9c9c;
        background: #ffffff;
        text-align: center;
      }
      .time-limit-input:focus {
        border: 1px solid #9c9c9c !important;
      }
    }
  }
}

.bot-mar {
  margin-bottom: 30px;
}

.bot-mars {
  margin-bottom: 41px;
}
</style>

